import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse} from '@angular/common/http';
import {delay, Observable, of} from 'rxjs';
import {Injectable} from '@angular/core';
import {MockDataService} from '@core-app/mocking/mock-data.service';
import {APP_CONFIG} from '@core-app/app.config';

@Injectable()
export class MockDataInterceptor implements HttpInterceptor {

    constructor(
        private mockDataService: MockDataService
    ) {
    }

    intercept(
        request: HttpRequest<any>,
        next: HttpHandler
    ): Observable<HttpEvent<any>> {
        if (APP_CONFIG.testMode) {
            const mockData = this.mockDataService.getMockData(request);
            if (mockData) {
                switch (request.url) {
                    default:
                        return of(new HttpResponse({status: 200, body: mockData})).pipe(
                            delay(200 + Math.random() * 300),
                        );
                }
            }
        }
        return next.handle(request);
    }

}
